// extracted by mini-css-extract-plugin
export var gif = "_ji-0";